import SC from "./style";
import { useEffect, useState } from "react";
import { apiPost } from "api/callApi";
import { Button, Label } from "InnoUI/components";
import theme from "theme";
import BulkActionView from "InnoUI/components/BulkActionView";
import { InputField } from "components";
import { showAlert } from "utils/helper";

function AddEditFolderTemplate(props) {
  const {
    isEditing,
    setOpenModalView,
    setIsEditing,
    openModalView,
    fieldData,
    rowData,
    fetchData,
    setFieldData,
  } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(fieldData || {});

  const handleChangeTemplate = (property, value) => {
    setData((prevData) => ({
      ...prevData,
      [property]: value,
    }));
  };

  useEffect(() => {
    if (isEditing) {
      setData(fieldData);
    }
  }, [isEditing, fieldData]);

  // Handle form submission for Add or Edit
  const handleSubmit = async () => {
    if (!data?.name) {
      // Validate if the 'name' field is empty
      showAlert({
        title: "Error",
        text: "Please provide template name",
        icon: "error",
      });
      return;
    }

    setLoading(true);
    try {
      const endpoint = isEditing ? `/v1/templates/${rowData}` : `/v1/templates`;
      const response = await apiPost(endpoint, data);
      setLoading(false);
      showAlert({ title: "Success", text: response?.message, icon: "success" });
      await fetchData();
      setData({});
      if (typeof setFieldData === "function") {
        setFieldData(null);
      }
      setOpenModalView(false);
    } catch (error) {
      console.error("Error:", error);
      showAlert({
        title: "Error",
        text: error?.response?.data?.message || "An error occurred",
        icon: "error",
      });

      setLoading(false);
      // if (typeof setFieldData === "function") {
      //   setFieldData(null);
      // }
    }
  };

  const handleCancelCompanyModal = () => {
    setOpenModalView(false);
    setData({});
    if (typeof setFieldData === "function") {
      setFieldData(null);
    }
  };
  const handleCancelCompanyModalisEditing = () => {
    setOpenModalView(false);
    setIsEditing(false);
    setData({});
    if (typeof setFieldData === "function") {
      setFieldData(null);
    }
  };

  const AddCompanyModalData = () => {
    return (
      <div>
        <div style={{ marginTop: "30px" }}>
          <Label label={"Template Name"}>
            <div style={{ display: "flex", padding: "0px" }}>
              <InputField
                name="name"
                value={data?.name}
                onChange={handleChangeTemplate}
                style={{ width: "100%" }}
                required
                // capitalize
              />
            </div>
          </Label>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            margin: "20px",
          }}
        >
          {isEditing ? (
            <Button
              caption="Cancel"
              onClick={handleCancelCompanyModalisEditing}
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.colors.cancelButton,
                color: theme.colors.white,
                minWidth: "90px",
                borderRadius: "3px",
                height: "30px",
                fontSize: "12px",
              }}
            />
          ) : (
            <Button
              caption="Cancel"
              onClick={handleCancelCompanyModal}
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.colors.cancelButton,
                color: theme.colors.white,
                minWidth: "90px",
                borderRadius: "3px",
                height: "30px",
                fontSize: "12px",
              }}
            />
          )}
          <Button
            caption={isEditing ? "Save" : "Add"}
            isLoading={loading}
            onClick={handleSubmit}
            color="white"
            fontSize="12px"
            style={{
              marginBottom: 8,
              background: theme.gradient.themeGradient,
              color: theme.colors.white,
              minWidth: "90px",
              height: "30px",
              borderRadius: "3px",
            }}
          />
        </div>
      </div>
    );
  };

  return (
    <>
      {openModalView &&
        (isEditing ? (
          <BulkActionView
            title={"Edit Template"}
            openModal={openModalView}
            renderBodyConditionally={AddCompanyModalData}
            handleCloseModal={() => {
              setOpenModalView(false);
              setIsEditing(false);
              setData("");
              if (typeof setFieldData === "function") {
                setFieldData(null);
              }
            }}
            sx={{
              minWidth: "550px",
            }}
          />
        ) : (
          <BulkActionView
            title={"New Folder Template"}
            openModal={openModalView}
            renderBodyConditionally={AddCompanyModalData}
            handleCloseModal={() => {
              setOpenModalView(false);
              setData("");
              if (typeof setFieldData === "function") {
                setFieldData(null);
              }
            }}
            sx={{
              minWidth: "550px",
            }}
          />
        ))}
    </>
  );
}

export default AddEditFolderTemplate;
